import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var separator = /*#__PURE__*/css("background-color:", tokens.colors.neutral.trim.default, ";");
export var row = /*#__PURE__*/css(separator, " height:", tokens.typography.body.size, ";width:1px;");
export var column = /*#__PURE__*/css(separator, " height:1px;width:100%;");